interface IResponseErrorMap {
  [key: string]: string | null | undefined;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function mapResponseErrors(errors: any[] = []): IResponseErrorMap {
  return errors.reduce<IResponseErrorMap>((result, error) => {
    if (typeof error === 'object' && typeof error.key === 'string') {
      const { key, message, code } = error as { key: string; message: string; code?: string };
      const errorKey = code || key;

      result[errorKey] = message;
    }

    return result;
  }, {});
}
